export const recursosInitialState = {
  obrasSemRecursos: [],
  recursos: [],
  encarregados: [],
  funcionarios: [],
  associarRecursos: [],
};
